import React, { useState, useEffect } from 'react';
import { DataBrowser } from 'cccisd-laravel-assignment';
import Loader from 'cccisd-loader';
import { client } from 'cccisd-apollo';
import deploymentsQuery from './deployments.graphql';

const ViewData = props => {
    const [deploymentIds, setDeploymentIds] = useState([]);
    const [groupId, setGroupId] = useState(null);
    const [loadingDeployments, setLoadingDeployments] = useState(false);

    useEffect(() => {
        setLoadingDeployments(true);
        getDeployments();
    }, []);

    const getDeployments = async () => {
        setLoadingDeployments(true);
        const orgId = window.cccisd.fortress.user.acting.group_id;
        const response = await client.query({
            query: deploymentsQuery,
            variables: {
                orgFilter: `org_${orgId}`,
            },
        });

        setDeploymentIds(response.data.flows.assignment.deploymentList.map(d => d.deploymentId));
        setGroupId(response.data.flows.assignment.groupId);
        setLoadingDeployments(false);
    };

    // console.log('deploymentIds', deploymentIds);

    if (loadingDeployments) {
        return <Loader loading />;
    }

    return (
        <div className="container-fluid">
            <p />
            <DataBrowser
                key={`key_${deploymentIds.join('-')}`}
                projectId={groupId}
                showDeploymentIds={deploymentIds}
                showQueriesWithTags={['demographics', 'feedback', 'scaledata']}
            />
        </div>
    );
};

export default ViewData;
